import { render } from "./BadScoreModal.vue?vue&type=template&id=18600ae0&scoped=true"
import script from "./BadScoreModal.vue?vue&type=script&lang=js"
export * from "./BadScoreModal.vue?vue&type=script&lang=js"

import "./BadScoreModal.vue?vue&type=style&index=0&id=18600ae0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18600ae0"]])

export default __exports__